// customerType.ts
// T-099 (v1.8.24): Kundentypen Privatkunde, Geschäftskunde, Verein, Verwaltung.
// Keine Sonderbehandlung (Preise, Rechnungen, Mails unverändert), nur Anzeige, Auswahl und Namensfeld.
// Die API liefert "Private" | "Business" | "Club" | "PublicAuthority" (gespeicherter Typ), sendet werden Kleinbuchstaben.

export type CustomerTypeCode = 'private' | 'business' | 'club' | 'publicauthority';

export const CUSTOMER_TYPE_OPTIONS: { value: CustomerTypeCode; label: string }[] = [
  { value: 'private', label: 'Privatkunde' },
  { value: 'business', label: 'Geschäftskunde' },
  { value: 'club', label: 'Verein' },
  { value: 'publicauthority', label: 'Verwaltung' }
];

/** API-Wert (beliebige Schreibweise) auf den Code abbilden; unbekannt oder leer = Privatkunde. */
export const normalizeCustomerType = (value?: string | null): CustomerTypeCode => {
  const v = (value || '').toString().trim().toLowerCase().replace(/[_\s-]/g, '');
  if (v === 'business' || v === 'geschäftskunde' || v === 'geschaeftskunde') return 'business';
  if (v === 'club' || v === 'verein') return 'club';
  if (v === 'publicauthority' || v === 'verwaltung' || v === 'behörde' || v === 'behoerde') return 'publicauthority';
  return 'private';
};

export const customerTypeLabel = (value?: string | null): string => {
  const code = normalizeCustomerType(value);
  return CUSTOMER_TYPE_OPTIONS.find(o => o.value === code)?.label || 'Privatkunde';
};

/** Alle Typen außer Privatkunde führen ein Namensfeld (Firma, Verein, Behörde). */
export const hasOrganizationName = (value?: string | null): boolean => normalizeCustomerType(value) !== 'private';

export const organizationNameLabel = (value?: string | null): string => {
  switch (normalizeCustomerType(value)) {
    case 'business': return 'Name der Firma';
    case 'club': return 'Name des Vereins';
    case 'publicauthority': return 'Name der Behörde / Verwaltung';
    default: return 'Firma';
  }
};
